export default "__VITE_ASSET__de27aeb7__"